
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qu’en est-il en Suisse?`}</em></p>
    <p>{`Notre pays a commandé
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/das-bag/aktuell/medienmitteilungen.msg-id-82224.html"
      }}>{`5 millions de doses`}</a>{`.
`}<a parentName="p" {...{
        "href": "587250788233"
      }}>{`Swissmedic`}</a>{` a annoncé le 19 avril que Curevac avait soumis une
demande d'autorisation.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;